import {Button, ButtonClass} from '@treez-ui/core/buttons/Button';
import {StoreIcon} from '@treez-ui/core/icons';
import React, {FunctionComponent} from 'react';
import {TreezColor, treezColorMap} from '~/styles/constants';

interface Props {
    storesHidden: boolean;
    toggleStoreView: () => void;
}

export const StoresToggle: FunctionComponent<Props> = (props: Props) => {
    const {storesHidden, toggleStoreView} = props;

    const white = treezColorMap[TreezColor.WHITE];

    const storesHiddenProps = {
        text: 'Show Stores',
        buttonClass: ButtonClass.PREFERRED,
        icon: <StoreIcon color={white} />,
    };

    const storesShownProps = {
        text: 'Hide Stores',
        buttonClass: ButtonClass.QUIET,
        icon: <StoreIcon />,
    };

    const buttonProps = storesHidden ? storesHiddenProps : storesShownProps;

    return <Button onClick={toggleStoreView} {...buttonProps} />;
};

export default StoresToggle;
